import { BaseTextField } from "@/shared/ui/base-text-field";
import { MobileDeliveryProposalFormTable } from "@/widgets/delivery-proposal-form-table/mobile-delivery-proposal-form-table";
import { Box } from "@mui/material";
import { type Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DeliveryProposalFormLayout } from "../../../../../widgets/delivery-proposal-form-layout";
import { DeliveryProposalFormTable } from "../../../../../widgets/delivery-proposal-form-table";
import type { AdminDeliveryProposalDetailPageProps } from "../../../model";
import type { CreateDeliveryProposalFormSchemaType } from "../../../model/validation";

export const MemoForm = (props: {
  control: Control<CreateDeliveryProposalFormSchemaType>;
  draftOfferCargo: AdminDeliveryProposalDetailPageProps["draftOfferCargo"];
}) => {
  const { t } = useTranslation();
  const { control } = props;

  const memoCells = [
    props.draftOfferCargo.data?.memo,
    <Controller
      key="proposal"
      name="memo"
      control={control}
      render={({ field, fieldState }) => (
        <BaseTextField
          {...field}
          multiline
          size="small"
          rows={4}
          fullWidth
          error={!!fieldState.invalid}
          helperText={fieldState.error?.message}
        />
      )}
    />,
  ];

  return (
    <DeliveryProposalFormLayout
      title={t("offerCargo.desitination.memo")}
      isLoading={false}
    >
      <div>
        {/* PC用のフォーム */}
        <Box display={{ xs: "none", sm: "block" }}>
          <DeliveryProposalFormTable
            headers={["荷物", "提案"]}
            rows={[
              {
                title: t("offerCargo.desitination.memo"),
                cells: memoCells,
              },
            ]}
          />
        </Box>

        {/* モバイル用のフォーム */}
        <Box display={{ xs: "block", sm: "none" }}>
          <MobileDeliveryProposalFormTable
            items={[
              {
                label: t("offerCargo.desitination.memo"),
                cargo: memoCells[0],
                proposal: memoCells[1],
              },
            ]}
          />
        </Box>
      </div>
    </DeliveryProposalFormLayout>
  );
};
